import React from 'react';
import Icon from '../../../components/AppIcon';

const LoginHeader = () => {
  return (
    <div className="text-center mb-8">
      {/* Logo */}
      <div className="flex items-center justify-center mb-6">
        <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center shadow-lg">
          <Icon name="Hotel" size={28} color="white" />
        </div>
      </div>

      {/* Welcome Message */}
      <div className="space-y-2">
        <h1 className="text-2xl font-bold text-slate-900">
          HNP Pro
        </h1>
        <p className="text-slate-600 text-sm">
          Faça login para acessar seu painel de gestão
        </p>
      </div>
    </div>
  );
};

export default LoginHeader;